import { ReactElement } from 'react';
import { Field } from 'formik';
import { TileRadioAccessibleReview } from '@components';
import { tileReview } from '@interfaces/interfaces';
import gridStyles from '@pages/forms/Grid.module.scss';
import { FamilyViolence, Homelessness, LongTermDisability, MentalOrIntellectualDisability, SubstanceAddiction } from './Statements/SpecialStatementsStep7';

function ReviewStep7(): ReactElement {
  const reviewGrounds: tileReview[] = [
    {
      body: <MentalOrIntellectualDisability />,
      subTitle: '',
      value: 'Mental or intellectual disability, disorder, disease or illness',
    },
    {
      body: <SubstanceAddiction />,
      subTitle: '',
      value: 'Alcohol, drug or volatile substance addiction',
    },
    {
      body: <Homelessness />,
      subTitle: '',
      value: 'Homelessness',
    },
    {
      body: <LongTermDisability />,
      subTitle: '',
      value: 'Disabling long-term circumstances making it impracticable to deal with the fine',
    },
    {
      body: <FamilyViolence />,
      subTitle: '',
      value: 'Family violence',
    }
  ];
  const filteredTileData = reviewGrounds;
  return (
    <>
      <div className="vfH2">Which statement(s) best describes your situation?</div>
      <p><i>You may select multiple options.</i></p>
      <div>
        <div className={gridStyles.gridColFull}>
          <div>
            <Field
              name="SelectedSpecialsGroundInfo"
              component={TileRadioAccessibleReview}
              title=""
              tileData={filteredTileData}
              isMandatory
              orientationColumn
              isMultiSelectable
              validateFieldName="selectTheSpecialOption" />
            <br />
            <br />
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewStep7;
